/**
 * The Telegram login widget script (telegram-widget.js) injects its own
 * `<iframe>` without a `title`, which axe-core flags as frame-title. The
 * widget renders asynchronously and gives us no load callback for the
 * iframe itself, so we watch the container it's injected into and title
 * the iframe as soon as it shows up.
 */
export function titleTelegramWidgetIframe(container: Element, title: string): () => void {
  const applyTitle = () => {
    const iframe = container.querySelector('iframe');
    if (iframe && !iframe.title) {
      iframe.title = title;
    }
  };

  applyTitle();

  const observer = new MutationObserver(applyTitle);
  observer.observe(container, { childList: true, subtree: true });

  return () => observer.disconnect();
}
